import { Navigate } from 'react-router-dom';
import OutageRequisition from '../../../modules/superAdmin/OutageRequisition';
import OutageReqDetail from '../../../modules/superAdmin/OutageRequisition/OutrageRequisitionDetail';
import Reports from '../../../modules/superAdmin/Reports';
import Settings from '../../../modules/superAdmin/Settings';
import NotificationList from '../../../modules/superAdmin/Settings/NotificationList';
import UserInfo from '../../../modules/superAdmin/Settings/UserInfo';
import PasswordSecurity from '../../../modules/superAdmin/Settings/PasswordSecurity';
import PrivacyPolicy from '../../../modules/superAdmin/Settings/PrivacyPolicy';

const routes = [
  {
    path: '/OutageRequisition',
    element: <OutageRequisition />,
  },
  {
    path: '/OutageRequisition/:id',
    element: <OutageReqDetail />,
  },
  {
    path: '/Report',
    element: <Reports />,
  },
  {
    path: '/settings',
    element: <Settings />,
    children: [
      //{ index: true, element: <UserInfo /> },
      { path: 'user-info', element: <UserInfo /> },
      { path: 'password', element: <PasswordSecurity /> },
      { path: 'notifications', element: <NotificationList /> },
      { path: 'privacy-policy', element: <PrivacyPolicy /> },
    ],
  },
  {
    path: '/notifications',
    element: <NotificationList />,
  },
  // 🚫 Catch all undefined or restricted routes
  {
    path: '*',
    element: <Navigate to="/login" replace />,
  },
];
export default routes;
